import React from 'react';

import { RestrictionsContext } from './RestrictionsContext';
import useRestrictions from './useRestrictions';

const Restrictions: React.FC = ({ children }) => {
    const restrictionsCtx = useRestrictions();

    return (
        <RestrictionsContext.Provider value={restrictionsCtx}>
            {children}
        </RestrictionsContext.Provider>
    );
};

export default Restrictions;
